import "phaser";

import { Game } from "./Game";
import { GameConstants } from "./GameConstants";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { RouletteScene } from "./scenes/roulette-scene/RouletteScene";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";
import { InfoScene } from "./scenes/info-scene/InfoScene";
import { PresentInfoScene } from "./scenes/present-info-scene/PresentInfoScene";
import { PrizesScene } from "./scenes/prizes-scene/PrizesScene";

let game: Game;

window.onload = () => {

    const gameConfig = {

        type: Phaser.AUTO,
        backgroundColor: "000000",
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width: GameConstants.GAME_WIDTH,
            height: GameConstants.GAME_HEIGHT
        },

        scene:  [
                    BootScene, 
                    PreloadScene, 
                    RouletteScene,
                    InfoScene,
                    PresentInfoScene,
                    PrizesScene
                ]
    };

    const game = new Game(gameConfig);

    window.focus();
    resize();
    window.addEventListener("resize", resize, false);
    window.addEventListener("orientationchange", checkOriention, false);
};

function resize(): void {

    const canvas = document.querySelector("canvas");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowRatio = windowWidth / windowHeight;

    const gameRatio = GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT;
    
    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    } else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
}

function checkOriention(): void {

    const w = window.innerWidth;
    const h = window.innerHeight;

    if (h > w) {

        if (!GameVars.intitialised) {
            
            setTimeout(function() { 
                GameManager.init(); 
            }, 300);
        }

        document.getElementById("orientation").style.display = "none";
        document.getElementById("content").style.display = "block";
    } else {
        document.getElementById("orientation").style.display = "block";
        document.getElementById("content").style.display = "none";
    }
}
